module.exports = __webpack_public_path__ + "static/RickMortyLab-11c14e6b1f15b5d3cb8266478470beb8.jpg";